<template>
    <div class="columns">
        <div class="column is-narrow">
            <label class="label" :style="{'display': 'inline-block', 'padding-top': paddingTop ? paddingTop : '24px'}">{{label}}</label>
        </div>
        <div class="column">
            <slot/>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SingleLineFormElement',
        props: ['label', 'paddingTop'],
        data() {
            return {
                modal: false,

            }
        }
    }
</script>